import { uppercaseAll, capitalizeFirst } from "@/directives";
export default {
  directives: {
    uppercase: uppercaseAll,
    capitalizeFirst: capitalizeFirst,
  },
};
